// extracted by mini-css-extract-plugin
module.exports = {"padding":"styles_padding__3cpVh","summaryError":"styles_summaryError__28ILq"};